import { RouteObject } from 'react-router-dom';
import LandingPage from '@/pages/landing/page';
import LoginPage from '@/pages/login/page';
import LoginForgotPasswordPage from '@/pages/login/password/page';
import RegisterPage from '@/pages/register/page';
import TermsOfServicePage from '@/pages/legal/terms/page';
import OrderPage from '@/pages/orders/page';
import OrderDetailPage from '@/pages/orders/detail/page';
import CreateOrderPage from '@/pages/orders/new/page';
import TeamPage from '@/pages/team/page';
import MePage from '@/pages/me/page';
import AvatarUploadPage from '@/pages/me/avatar/page';
import PersonalInfoPage from '@/pages/me/profile/page';
import ServiceAreasPage from '@/pages/me/service-areas/page';
import ChangePasswordPage from '@/pages/me/password/page';
import PasswordVerifyPage from '@/pages/me/password/verify/page';
import HelpSupportPage from '@/pages/me/support/page';
import MyWalletPage from '@/pages/me/wallet/page';
import WorkStatisticsPage from '@/pages/me/statistics/page';
import TeamStatisticsPage from '@/pages/team/statistics/page';
import TeamJoinPage from '@/pages/team/join/page';
import TeamCreatePage from '@/pages/team/create/page';
import TeamSettingsPage from '@/pages/team/settings/page';
import TeamLogoUploadPage from '@/pages/team/settings/logo/page';
import InvoiceSettingsPage from '@/pages/team/invoice/page';
import TeamMembersPage from '@/pages/team/members/page';
import RecurringOrdersPage from '@/pages/team/recurring/page';
import TeamInfoPage from '@/pages/team/info/page';
import TeamAllOrdersPage from '@/pages/team/orders/page';
import SubscribePage from '@/pages/subscribe/page';
import SubscribeOrdersPage from '@/pages/subscribe/orders/page';
import SubscribePaymentResultPage from '@/pages/subscribe/payment-result/page';
import NotFound from '@/pages/NotFound';
import PrivateRoute from '@/components/feature/PrivateRoute';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/login/password',
    element: <LoginForgotPasswordPage />,
  },
  {
    path: '/login/password/verify',
    element: <PasswordVerifyPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/terms',
    element: <TermsOfServicePage />,
  },
  {
    path: '/orders',
    element: <PrivateRoute><OrderPage /></PrivateRoute>,
  },
  {
    path: '/orders/new',
    element: <PrivateRoute><CreateOrderPage /></PrivateRoute>,
  },
  {
    path: '/orders/:orderId',
    element: <PrivateRoute><OrderDetailPage /></PrivateRoute>,
  },
  {
    path: '/team',
    element: <PrivateRoute><TeamPage /></PrivateRoute>,
  },
  {
    path: '/team/create',
    element: <PrivateRoute><TeamCreatePage /></PrivateRoute>,
  },
  {
    path: '/team/settings',
    element: <PrivateRoute><TeamSettingsPage /></PrivateRoute>,
  },
  {
    path: '/team/settings/logo',
    element: <PrivateRoute><TeamLogoUploadPage /></PrivateRoute>,
  },
  {
    path: '/team/invoice',
    element: <PrivateRoute><InvoiceSettingsPage /></PrivateRoute>,
  },
  {
    path: '/team/members',
    element: <PrivateRoute><TeamMembersPage /></PrivateRoute>,
  },
  {
    path: '/team/recurring',
    element: <PrivateRoute><RecurringOrdersPage /></PrivateRoute>,
  },
  {
    path: '/team/orders',
    element: <PrivateRoute><TeamAllOrdersPage /></PrivateRoute>,
  },
  {
    path: '/team/statistics',
    element: <PrivateRoute><TeamStatisticsPage /></PrivateRoute>,
  },
  {
    path: '/team/info/:teamId',
    element: <PrivateRoute><TeamInfoPage /></PrivateRoute>,
  },
  {
    path: '/subscribe',
    element: <PrivateRoute><SubscribePage /></PrivateRoute>,
  },
  {
    path: '/subscribe/orders',
    element: <PrivateRoute><SubscribeOrdersPage /></PrivateRoute>,
  },
  {
    path: '/subscribe/payment-result',
    element: <PrivateRoute><SubscribePaymentResultPage /></PrivateRoute>,
  },
  {
    path: '/me',
    element: <PrivateRoute><MePage /></PrivateRoute>,
  },
  {
    path: '/me/avatar',
    element: <PrivateRoute><AvatarUploadPage /></PrivateRoute>,
  },
  {
    path: '/me/profile',
    element: <PrivateRoute><PersonalInfoPage /></PrivateRoute>,
  },
  {
    path: '/me/service-areas',
    element: <PrivateRoute><ServiceAreasPage /></PrivateRoute>,
  },
  {
    path: '/me/password',
    element: <PrivateRoute><ChangePasswordPage /></PrivateRoute>,
  },
  {
    path: '/me/password/verify',
    element: <PrivateRoute><PasswordVerifyPage /></PrivateRoute>,
  },
  {
    path: '/me/support',
    element: <PrivateRoute><HelpSupportPage /></PrivateRoute>,
  },
  {
    path: '/me/wallet',
    element: <PrivateRoute><MyWalletPage /></PrivateRoute>,
  },
  {
    path: '/me/statistics',
    element: <PrivateRoute><WorkStatisticsPage /></PrivateRoute>,
  },
  {
    path: '/me/team/join',
    element: <PrivateRoute><TeamJoinPage /></PrivateRoute>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;